import { SIGN_OUT_SUCCESS } from 'modules/auth/action-types'
import { SET_CURRENT_QUEUE } from '../action-types'

export default function(state = null, {type, payload}) {
  switch (type) {
    case SET_CURRENT_QUEUE:
      return payload

    case SIGN_OUT_SUCCESS:
      return null

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/queues/reducers/current-queue.js